// extracted by mini-css-extract-plugin
module.exports = {"tablerow":"PlayerCard_tablerow__TTKc-","listitem":"PlayerCard_listitem__ifVMW","dead":"PlayerCard_dead__kdO5d","alive":"PlayerCard_alive__1cttF","bonus":"PlayerCard_bonus__2hoQp"};